// import store from '@/store'
import consts from "@/consts";
const routes = !consts.app.$isTestVersion ? [] : [
    {
        path: '/icons',
        name: 'icons',
        meta: {
        },
        components: {
            default: () => import('@/views/test/IconsPage.vue'),
        },
    },
]

export default routes